import * as types from '../types'

// 变量名
const defaultState = {
  tableList: []
}

/**
 * loading加载动画 reducer
 * state: 默认值为defaultState
 * action：调用时需要传的参数
 * */
export default function order(state = defaultState, action = {}) {
  const { 
    type,     // 调用时传的方法名
    payload     // 调用时传的参数
  } = action
  const res = Object.assign({}, state)
  switch (type) {
    // 添加货品明细列表
    case types.ORDER_ADD_GOODS_INFO:
      const addList = [...res.tableList]
      addList.push(payload.item)
      return Object.assign({}, state, {tableList: addList})
    case types.ORDER_DEL_GOODS_INFO:
      const delList = [...res.tableList]
      delList.forEach((item, i)=>{
        if(item.id === payload.id) {
          delList.splice(i, 1)
        }
      })
      return Object.assign({}, state, {tableList: delList})
    case types.ORDER_UPDATE_GOODS_INFO:
      return Object.assign({}, state, {tableList: payload.list})
    default:
      return state

  }
  return res
}